import { isTokenExpired, refreshDpaIdToken } from "@/compositions/token-utils";
import { NavigationGuard } from "vue-router";
import { getInstance } from "../../auth0-plugin";

export const authenticatedGuard: NavigationGuard = async (to, from, next) => {
  const authService = getInstance();
  const token = localStorage.getItem("dpaID-token");

  const guardAction = async () => {
    if (authService.isAuthenticated) {
      if (!token || isTokenExpired(token)) {
        await refreshDpaIdToken();
      }
      next();
    } else {
      authService.loginWithRedirect({ appState: { targetPath: to.fullPath } });
      next(false);
    }
  };

  if (!authService.isLoading) {
    return await guardAction();
  }

  authService.$watch("isLoading", async (isLoading: boolean) => {
    if (isLoading === false) {
      return await guardAction();
    }
  });
};

export default [authenticatedGuard];
